import { createStore, applyMiddleware, AnyAction } from "redux"
import { useSelector, useDispatch, TypedUseSelectorHook } from "react-redux"
import thunkMiddleware, { ThunkDispatch } from "redux-thunk"
import { composeWithDevTools } from "redux-devtools-extension"
import rootReducer from "./reducer"

const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware))

// The store now has the ability to accept thunk functions in `dispatch`
const store = createStore(rootReducer, composedEnhancer)

export default store

export type AppState = ReturnType<typeof rootReducer>
type TypedDispatch<T> = ThunkDispatch<T, unknown, AnyAction>

export const useAppDispatch = () => useDispatch<TypedDispatch<AppState>>()
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector
